// src/components/UserFiles/UserFilesListHeader.jsx

import React from 'react';
import { Box, Typography, FormControl, Select, MenuItem } from '@mui/material';

const UserFilesListHeader = ({
  t,
  pageSize,
  onPageSizeChange,
  compact = false,
  hideTitle = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: compact ? 'center' : 'flex-end',
        justifyContent: 'flex-end',
        gap: compact ? 1.5 : 2, // slightly softened gap
        mb: 0,
      }}
    >
      {!hideTitle && (
        <Typography variant={compact ? 'body2' : 'h6'} sx={{ mb: 0, fontWeight: 600 }}>
          {t('files.list_title', 'Vaše súbory')}
        </Typography>
      )}

      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, fontWeight: 500 }}>
          {t('files.page_size', 'Na stránke')}
        </Typography>
        <Select
          value={pageSize}
          onChange={(e) => onPageSizeChange?.(Number(e.target.value))}
          sx={{ 
            borderRadius: 2, 
            bgcolor: 'background.paper' 
          }}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default UserFilesListHeader;